import React from 'react';

class CadastrarMovimentacaoConf extends React.Component {

    data(dt) {

        let vec = dt.split("-");
        let dia = vec[2];
        let mes = vec[1];
        let ano = vec[0];

        return dia + " / " + mes + " / " + ano;

    }

    ghg(g) {
        if (g) return "Sim";
        else return "Não";
    }

    render() {
        return(
            <div>
                <p id="cadmovimentacao-conf-alerta">
                    Verifique as informações da movimentação financeira 
                    antes de confirmar o cadastro.
                </p><br /><br />
                <p id="cadmovimentacao-conf-data">
                    <b>Data:</b> { this.data(this.props.data) }
                </p><br />
                <table id="cadmovimentacao-conf-tbl">
                    <tbody>
                        <tr>
                            <td><b>GHG:</b></td>
                            <td>{ this.ghg(this.props.ghg) }</td>
                        </tr>
                        <tr>
                            <td><b>Banco:</b></td>
                            <td>{ this.props.bancos[this.props.banco] }</td>
                        </tr>
                        <tr>
                            <td><b>Conta:</b></td>
                            <td>{ this.props.conta !== "" &&
                                    this.props.contas[this.props.conta].cod_conta + " - " +
                                    this.props.contas[this.props.conta].conta }</td>
                        </tr>
                        <tr>
                            <td><b>Código da Conta:</b></td>
                            <td>{ this.props.codigoConta }</td>
                        </tr>
                        <tr>
                            <td><b>Código da Movimentação:</b></td>
                            <td>{ this.props.codigo }</td>
                        </tr>
                        <tr>
                            <td><b>Histórico:</b></td>
                            <td>{ this.props.historico }</td>
                        </tr>
                        <tr>
                            <td><b>Descrição da Movimentação:</b></td>
                            <td>{ this.props.descricao }</td>
                        </tr>
                        <tr>
                            <td><b>Valor:</b></td>
                            <td>{ this.props.valor !== "" && "R$ " } { this.props.valor }</td>
                        </tr>
                        <tr>
                            <td><b>Documento Fiscal:</b></td>
                            <td>{ this.props.notaFiscal !== null &&
                                    this.props.notaFiscal.name }</td>
                        </tr>
                        <tr>
                            <td><b>Comprovante de Pagamento:</b></td>
                            <td>{ this.props.comprovante !== null &&
                                    this.props.comprovante.name }</td>
                        </tr>
                        <tr>
                            <td><b>Análise Contábil:</b></td>
                            <td>{ this.props.analiseContabil }</td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <form id="cadmovimentacao-conf-form">
                    <button type="button" id="cadmovimentacao-voltar-btn" onClick={ this.props.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="cadmovimentacao-confirmar-btn"
                        onClick={ this.props.confirmar }
                        disabled={ this.props.disabled }>
                        Confirmar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default CadastrarMovimentacaoConf;

